// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/snow-surface-operations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/snow-surface-operations/snow-surface-operations.js';

mount([g0]);
